import type { ApiClient } from '../index';

/**
 * Phase 15 (PUSH-01) — device push-token lifecycle endpoints.
 *
 * - `registerToken` upserts an FCM token + platform pair (server derives userId
 *   from the JWT, never trusts a body field).
 * - `revokeToken` deletes a server-side token row; called on logout or settings
 *   toggle OFF so a stale device can't keep receiving messages (T-15-09).
 *
 * Backend contract lives in apps/api/src/modules/push/push.controller.ts.
 */
export type PushPlatform = 'web' | 'ios' | 'android';

export interface RegisterPushTokenInput {
  token: string;
  platform: PushPlatform;
}

export class PushEndpoints {
  constructor(private readonly client: ApiClient) {}

  registerToken(input: RegisterPushTokenInput): Promise<{ ok: true }> {
    return this.client.post<{ ok: true }>('/push/tokens', input);
  }

  revokeToken(token: string): Promise<void> {
    return this.client.delete<void>(`/push/tokens/${encodeURIComponent(token)}`);
  }
}
